<template>
    <div class="green-subtitle">
        <h4>{{ subtitle }}</h4>
    </div>
</template>

<script>
export default {
    props: {
        subtitle: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.green-subtitle{
    background: #cdfaee;
    padding: 5px 20px;
    min-height: 37px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 15px 0;
}
.green-subtitle h4{
    color: #545a6f;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
}
</style>